<template>
    <div class="activity-boost-detail">
        <!-- Tab 筛选栏 -->
        <div class="tabs-sticky">
            <van-tabs v-model="activeTab"
                color="#256FFF"
                title-active-color="#256FFF"
                title-inactive-color="#191919"
                line-height="3px">
                <van-tab v-for="tab in tabs"
                    :key="tab.value"
                    :title="tab.label"
                    :name="tab.value">
                </van-tab>
            </van-tabs>
        </div>

        <!-- 温馨提示横幅 -->
        <div v-if="showNotice" class="notice-banner">
            <div class="notice-text">
                <div class="notice-title">温馨提示：</div>
                <div class="notice-content">1、助力者删除企微后，无法重新被邀请；2、助力者删除企微后，抽奖机会可能会被回收。</div>
            </div>
            <div class="notice-close" @click="showBanner = false"></div>
        </div>

        <!-- 助力列表 -->
        <van-list :key="activeTab"
            v-model="loading"
            :finished="finished"
            :finished-text="boostList.length > 0 ? '已加载全部' : ''"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="fetchBoostList"
            class="boost-list">
            <div v-for="(item, index) in boostList"
                :key="index"
                class="boost-item">
                <!-- 状态印章 -->
                <img v-if="statusImgMap[String(item.relationStatus)]" class="status-stamp" :src="statusImgMap[String(item.relationStatus)]" />
                <!-- 头像 -->
                <van-image class="item-avatar"
                    round
                    :src="item.userHeadPortraitUrl || defaultAvatar"
                    width="26"
                    height="26"
                    fit="cover" />
                <!-- 好友信息 -->
                <div class="item-info">
                    <div class="item-name item-pad">{{ item.nickName ||'微信用户' }}</div>
                    <div v-if="item.lastEntryTime" class="item-row item-pad">
                        <span class="lbl">邀请时间：</span><span class="val">{{ item.lastEntryTime }}</span>
                    </div>
                    <div v-if="item.addFriendTime" class="item-row item-pad">
                        <span class="lbl">助力时间：</span><span class="val">{{ item.addFriendTime }}</span>
                    </div>
                    <div v-if="item.deleteFriendTime" class="item-row item-pad">
                        <span class="lbl">取消时间：</span><span class="val">{{ item.deleteFriendTime }}</span>
                    </div>
                    <template v-if="item.failReason">
                        <van-divider :style="{ margin: '10px 0', borderColor: '#D8D8D8' }" />
                        <div class="item-row">
                            <span class="lbl">失败原因：</span><span class="val">{{ item.failReason }}</span>
                        </div>
                    </template>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-if="finished && boostList.length === 0" class="empty-state">
                <img src="../../../../../static/image/activityCenter/noData.png" class="empty-img" />
                <p>暂无数据</p>
            </div>
        </van-list>
    </div>
</template>

<script>
import { Tabs, Tab, List, Image as VanImage, Divider } from 'vant';
import utils from '../../../../utils/comUtils.js';

export default {
  name: 'ActivityBoostDetail',
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    [VanImage.name]: VanImage,
    [Divider.name]: Divider,
  },
  data() {
    return {
      activityCode: '', // 活动编码，从路由 query 传入
      taskCode: '',     // 任务编码，从路由 query 传入
      activeTab: 'all', // 当前选中 tab，'all' 表示全部，'0'邀请成功 '1'待助力 '2'邀请失败
      showBanner: true, // 是否显示温馨提示横幅
      // loading: 	是否处于加载状态，加载过程中不触发load事件
      //   true  → 正在请求中，van-list 不会再触发 @load
      //   false → 请求完成，van-list 可以继续监听滚动触底
      loading: false,
      // finished: 	是否已加载完成，加载完成后不再触发load事件
      //   false → 还有更多数据，滚动到底时继续触发 @load
      //   true  → 数据已加载完，显示"已加载全部"，不再触发 @load
      finished: false,
      error: false,
      page: 0, // 当前已加载页数，请求时传 page+1，成功后 +1
      tabs: [
        { label: '全部', value: 'all' },        
        { label: '待助力', value: '1' },   
        { label: '邀请成功', value: '0' }, 
        { label: '邀请失败', value: '2' }, 
      ],
      // 状态印章图片映射，key 与接口返回的 relationStatus 一致
      statusImgMap: {
        '0': require('../../../../../static/image/activity-boost/success.svg'),
        '1': require('../../../../../static/image/activity-boost/pending-boost.svg'),
        '2': require('../../../../../static/image/activity-boost/failure.svg'),
      },
      boostList: [], // 当前 tab 已加载的原始列表（切换 tab 时清空重新加载）
      defaultAvatar: 'https://hshop.honorfile.com/pimages//pages/cdnImages/79067167008616176097.png',
    };
  },
  computed: {
    showNotice() {
      return this.showBanner && this.boostList.length > 0;
    },
  },
  watch: {
    activeTab() {
      this.boostList = [];
      this.page = 0;
      this.finished = false;
      this.loading = false;
      this.error = false;
    },
  },
  created() {
    document.title = '邀请明细';
    const query = this.$route ? this.$route.query || {} : {};
    this.activityCode = query.activityCode || '';
    this.taskCode = query.taskCode || '';
    this.reportPageView();
  },
  methods: {
    // 进入页面埋点上报
    reportPageView() {
      // mid、unionid（由 handleBatchReport 内部从 sessionStorage 自动读取）、活动编码、任务编码
      const params = {
        actionCode: '400070014',
        actionName: '进入邀请明细页',
        content: {
          title: '进入邀请明细页',
          activityCode: this.activityCode,
          taskCode: this.taskCode,
        },
      };
      console.log('邀请明细页埋点上报参数===>', params);
      utils.handleBatchReport(this, params);
    },
    fetchBoostList() {
      const pageSize = 10;
      const params = {
        curPage: this.page + 1,
        pageSize,
        filter: {
          taskCode: this.taskCode,
          activityCode: this.activityCode,
          // activeTab 为 'all' 时不传 relationType，后端返回全部；否则传对应状态值
          relationType: this.activeTab !== 'all' ? this.activeTab : '',
        },
      };
      this.$api.post({
        sc: 'mobileMarketingH5',
        url: 'activityTask/userRelationList',
        params,
        success: (res) => {
          if (res && res.code === 200) {
            const list = res.result || [];
            const pagingMap = list[0] && list[0].pagingMap || {};
            const totalRows = pagingMap.totalRows || 0;
            this.page += 1;
            this.boostList = [...this.boostList, ...list];
            this.loading = false;
            this.finished = this.boostList.length >= totalRows;
          } else {
            this.loading = false;
            this.error = true;
          }
        },
        failure: () => {
          this.loading = false;
          this.error = true;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-boost-detail {
  min-height: 100vh;
  background: #f2f3f6;

  /* Tab 栏吸顶：外层 div 控制高度和裁切，彻底隐藏 van-tabs__content 白区域 */
  .tabs-sticky {
    position: sticky;
    top: 0;
    z-index: 99;
    background: #fff;
    height: 44px;
    overflow: hidden;
  }

  /deep/ .van-tabs__line {
    width: 28px !important;
  }
  /deep/ .van-tab--active {
    font-weight: 700;
  }

  /* 温馨提示横幅 */
  .notice-banner {
    position: sticky;
    top: 44px;
    z-index: 98;
    height: 68px;
    background: #fefcec;
    padding: 10px 16px;
    box-sizing: border-box;

    .notice-text {
      height: 48px;
      overflow: hidden;
      padding-right: 32px;
      line-height: 16px;

      .notice-title {
        font-size: 12px;
        font-weight: bold;
        color: #e47a1c;
      }

      .notice-content {
        font-size: 12px;
        color: #e47a1c;
      }
    }

    .notice-close {
      position: absolute;
      top: 9px;
      right: 16px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 1.5px;
        height: 13px;
        background: #e47a1c;
        border-radius: 1px;
      }
      &::before { transform: rotate(45deg); }
      &::after  { transform: rotate(-45deg); }
    }
  }

  /* 列表区域 */
  .boost-list {
    padding: 10px 16px 10px;
    background: #f2f3f6;
  }

  /* 卡片 */
  .boost-item {
    position: relative;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 10px 12px;
    display: flex;
    align-items: flex-start;

    .status-stamp {
      position: absolute;
      top: 4px;
      right: 4px;
      width: 50px;
      height: 42px;
      object-fit: contain;
    }

    .item-avatar {
      flex-shrink: 0;
      margin-right: 10px;

      /deep/ .van-image {
        display: block;
        width: 26px;
        height: 26px;
      }
    }

    .item-info {
      flex: 1;
      min-width: 0;
      padding-top: 4px;

      /* 只有内容行需要为右侧印章留空间，divider 不受影响 */
      .item-pad {
        padding-right: 56px;
      }

      .item-name {
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
        color: #3d3d3d;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item-row {
        font-size: 12px;
        line-height: 16px;

        .lbl { color: #999; }
        .val { color: #3d3d3d; }
      }

      /* 相邻两行之间 4px 间距，最后一行不留底部 margin */
      .item-row + .item-row {
        margin-top: 4px;
      }
    }
  }

  .empty-state {
    height: calc(100vh - 64px); /* 减去 tab(44px)、boost-list padding-top(10px)、padding-bottom(10px) */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 54px;

    .empty-img {
      width: 216px;
      height: auto;
    }

    p {
      margin-top: 4px;
      font-size: 14px;
      color: rgba(0,0,0,0.6);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activity-boost/activity-boost-detail.vue